import React from "react";
import Widget from "components/Widget";

const InfoItem = ({index, icon, title, description}) => {
    return (
        <div
            key={index}
            className="media align-items-center flex-nowrap jr-pro-contact-list mb-0"
            >
            <div className="mr-3">
                <i
                className={`zmdi zmdi-${icon} jr-fs-xxl text-grey`}
                />
            </div>
            <div className="media-body">
                <span className="mb-0 text-grey jr-fs-sm">
                    {title}
                </span>
                <p className="mb-0">{description}</p>
            </div>
        </div>
    );
}; 

const ContactInfo=({ prescription })=>{
    const { institution } = prescription.doctor;
    return (
        <div className="col-xl-4 col-lg-4 col-md-12 col-10">
            <Widget
                title="Información de contacto"
                styleName="jr-card-profile-sm"
                >
                <InfoItem index={0}
                    icon="city-alt"
                    title="Institución"
                    description={institution}/>
            </Widget>
        </div>
    );
};

export default ContactInfo;
